<template>
	<div
			:class="{ 'too-long': isTooLong, 'hide': !showIndicator }"
			class="text-length-indicator"
	>
		<span class="length">{{ length }}</span> <span v-if="max">/ {{ max }}</span>
	</div>
</template>

<script lang="ts" setup>
	import {computed} from 'vue';

	const props = defineProps({
		max: {
			type: Number,
			default: undefined
		},
		length: {
			type: Number,
			default: 0
		}
	});

	const isTooLong = computed(() => {
		return props.max !== undefined && props.length > props.max;
	});

	const showIndicator = computed(() => {
		return props.max && props.max / 3 * 2 < props.length;
	});
</script>

<style scoped>
	.text-length-indicator {
		color: var(--color-grey-300);
		text-align: right;
		position: relative;
		font-size: var(--font-size-p-1);
		line-height: var(--line-height-p-1);
		padding-top: 2px;
	}

	.length {
		min-width: 2.5em;
		display: inline-block;
	}

	.too-long {
		color: var(--color-error);
		font-weight: bold;
	}

	.hide {
		visibility: hidden;
	}
</style>
